/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Traditional)
export default {
  'company-hub-common.ai.error.common-error.general-error':
    'Atlassian Intelligence 目前無法提供回應。請參閱<a>我們的支援說明文件</a>。',
  'company-hub-common.ai.error.common-error.not-enough-content':
    '這裡沒有足夠的內容可以提供摘要。請新增更多內容並再試一次。',
  'company-hub-common.ai.error.common-error.rate-limit':
    '我們發現 Atlassian Intelligence 使用過量。請稍後再試一次。請參閱<a>我們的支援說明文件</a>。',
  'company-hub-common.ai.error.page-error.aup-violation':
    '您的內容可能不符合我們的《可接受使用政策》。如有需要，請查看並參閱我們的<a>《可接受使用政策》</a>。',
  'company-hub-common.ai.error.page-error.too-much-content':
    'Atlassian Intelligence 目前無法為您產生摘要，因為需要摘要的內容太多。',
  'company-hub-common.attachment-size-limit-error.description': '附件必須小於或等於 {size}。',
  'company-hub-common.attachment-size-limit-error.learn-more': '深入了解',
  'company-hub-common.attachment-size-limit-error.title': '{fileName} 太大，無法上傳',
  'company-hub-common.attachment-zero-byte-error.title': '{fileName} 空白 (零位元組)',
  'company-hub-common.attachment-zero-byte.description': '附件大小必須至少為 1 個位元組',
  'company-hub-common.config-panel.new-lozenge-label': '新',
  'company-hub-common.config-panel.panel-close-button.close-label': '關閉組態面板',
  'company-hub-common.emoji-title.icon.embed': '嵌入',
  'company-hub.common.media-components.media-picker.ui.content.inspiration.text': '需要靈感嗎？',
  'company-hub.common.media-components.media-picker.ui.content.placeholder.text': '透過 URL 新增連結',
  'company-hub.common.media-components.unsplash.unsplash-browser.button.text': '瀏覽 unsplash',
  'company-hub.common.media-components.unsplash.unsplash-browser.error.text':
    '我們在存取此連結時遇到問題。請再試一次。',
  'company-hub.company-hub-common.ui.empty-state.label-placeholder': '標籤',
  'custom-sites-extensions.config-panel.add-card-cta': '新增卡片',
  'custom-sites-extensions.config-panel.content.label-button.popup.hide-label-button.text': '隱藏標籤',
  'custom-sites-extensions.config-panel.content.label-button.popup.title': '標籤',
  'custom-sites-extensions.config-panel.content.label-button.title': '標籤',
  'custom-sites-extensions.config-panel.feedback-collector.preamble.first-line':
    '您的意見非常寶貴，能讓我們知道如何更加符合您的需求。有什麼可以改善的嗎？',
  'custom-sites-extensions.config-panel.feedback-collector.summary-placeholder':
    '哪些功能效果很好？有哪裡可以改善的嗎？',
  'custom-sites-extensions.config-panel.feedback-section.preamble': '您的意見反應有助於我們改善產品。',
  'custom-sites-extensions.config-panel.feedback-section.share-feedback-button.text-extension':
    '{type, select, Cards {提供有關卡片的意見反應} Carousel {提供有關輪播的意見反應} Linksmenu {提供有關連結選單的意見反應} Spotlight {提供有關聚光燈的意見反應} Section {提供有關「區段」的意見反應} Customsearch {針對自訂搜尋提供意見反應} Companyhub {提供有關公司中心的意見反應} other {分享您的想法}}',
  'custom-sites-extensions.config-panel.render-variant.dropdown.label': '卡片類型',
  'custom-sites-extensions.config-panel.render-variant.dropdown.option.label.dynamic': '動態',
  'custom-sites-extensions.config-panel.render-variant.dropdown.option.label.manual': '手動',
  'custom-sites-extensions.link-cards-content.card-components.error-states.loading-cards-error-preamble':
    '我們在載入這些卡片時遇到問題。',
  'custom-sites-extensions.link-cards-content.card-components.error-states.loading-cards-error-support':
    '請重新載入以再試一次。',
  'custom-sites-extensions.link-cards.card.collapse.label': '摺疊卡片',
  'custom-sites-extensions.link-cards.card.expand.label': '展開卡片',
  'custom-sites-extensions.link-cards.card.image.section.label': '圖片',
  'custom-sites-extensions.link-cards.card.remove.card.label': '移除卡片',
  'custom-sites-extensions.link-cards.card.title': '卡片 {order}',
  'custom-sites-extensions.link-cards.cards-area-container-components.draggable-card-container.arrow.down': '向下',
  'custom-sites-extensions.link-cards.cards-area-container-components.draggable-card-container.arrow.up': '向上',
  'custom-sites-extensions.link-cards.cards-area-container-components.draggable-card-container.move.down.label': '下移',
  'custom-sites-extensions.link-cards.cards-area-container-components.draggable-card-container.move.up.label':
    '向上移動',
  'custom-sites-extensions.link-cards.cards-area-container-components.draggable-card-container.reorder': '重新排序',
  'custom-sites-extensions.link-cards.description.ai-disclaimer': '內容品質可能會變動',
  'custom-sites-extensions.link-cards.description.button.suggest-description.label': '建議描述',
  'custom-sites-extensions.link-cards.description.link.label.ai': '進一步了解 Atlassian 人工智慧',
  'custom-sites-extensions.link-cards.error-states.no-data.description-text': '請嘗試刪除此巨集並建立新的巨集。',
  'custom-sites-extensions.link-cards.error-states.no-data.header-text': '沒有可顯示的資料',
  'custom-sites-extensions.link-cards.fetch-cover-image.fetch.error.description': '請重新整理頁面，然後再試一次',
  'custom-sites-extensions.link-cards.fetch-cover-image.fetch.error.title': '我們無法上傳您的圖片',
  'custom-sites-extensions.link-cards.image-failed-to-load': '圖片無法載入',
  'custom-sites-extensions.link-cards.link-cards-config-panel.alignment-text-label.v2': '對齊',
  'custom-sites-extensions.link-cards.link-cards-config-panel.alignment-text-label.v2.center': '置中',
  'custom-sites-extensions.link-cards.link-cards-config-panel.alignment-text-label.v2.left': '靠左',
  'custom-sites-extensions.link-cards.link-cards-config-panel.alignment-text-label.v2.right': '靠右',
  'custom-sites-extensions.link-cards.link-cards-config-panel.segmentation-target-field.drop-down.item.all-cards.label':
    '所有卡片',
  'custom-sites-extensions.link-cards.link-cards-config-panel.segmentation-target-field.drop-down.item.each-card.label':
    '每張卡片',
  'custom-sites-extensions.link-cards.link-cards-config-panel.segmentation-target-field.drop-down.item.v2.all-cards.label':
    '全部卡片',
  'custom-sites-extensions.link-cards.link-cards-config-panel.segmentation-target-field.drop-down.item.v2.each-card.label':
    '每張卡片',
  'custom-sites-extensions.link-cards.link-cards-config-panel.segmentation-target-field.drop-down.v2.item.no-segmentation.label':
    '無',
  'custom-sites-extensions.link-cards.link-cards-config-panel.segmentation-target-field.info-label':
    '為每張卡片新增目標群組',
  'custom-sites-extensions.link-cards.link-cards-config-panel.segmentation-target-groups-text-label': '目標群組',
  'custom-sites-extensions.link-cards.link-cards-config-panel.segmentation-target-groups-text-label.v2': '目標受眾群',
  'custom-sites-extensions.link-cards.link-cards-config-panel.segmentation-target-text-label': '目標內容：',
  'custom-sites-extensions.link-cards.link-cards-config-panel.segmentation-target-text.v2.label': '目標受眾',
  'custom-sites-extensions.link-cards.link-cards-config-panel.type-field.toggle.info-icon-label-v2':
    '選擇哪些 Confluence 使用者群組會看到您的卡片',
  'custom-sites-extensions.link-cards.warning': '無法載入圖片的警告圖示',
  'custom-sites-extensions.link.cards.image.upload.error.flag.description': '請重新整理頁面，然後再試一次。',
  'custom-sites-extensions.link.cards.image.upload.error.flag.title': '我們無法上傳您的圖片',
  'custom-sites-extensions.links-menu.corner.style': '角落樣式',
  'custom-sites-extensions.links-menu.corner.style-round': '圓形',
  'custom-sites-extensions.links-menu.corner.style-square': '正方形',
  'custom-sites-extensions.refined.unsplash.search.placeholder': '瀏覽 Unsplash',
  'custom-sites-extensions.shared-components.item.collapse.label':
    '{itemLabel, select, card {摺疊卡片} frame {摺疊框架} other {摺疊卡片}}',
  'custom-sites-extensions.shared-components.item.expand.label':
    '{itemLabel, select, card {展開卡片} frame {展開框架} other {展開卡片}}',
  'custom-sites-extensions.shared-components.item.remove.label':
    '{itemLabel, select, card {移除卡片} frame {移除框架} other {移除卡片}}',
  'custom-sites-extensions.shared-components.item.title':
    '{itemLabel, select, card {卡片 {order}} frame {框架 {order}} other {卡片 {order}}}',
  'custom-sites-extensions.shared-components.link-picker.clear-icon-label': '清除連結選取',
  'custom-sites-extensions.shared-components.link-picker.popup-placeholder-text': '新增任何連結',
  'custom-sites-extensions.shared-components.unsplash-search.upload.error.description': '請重新整理頁面，然後再試一次',
  'custom-sites-extensions.shared-components.unsplash-search.upload.error.title': '圖片無法載入',
  'custom-sites-extensions.spotlight.button-label.placeholder': '檢視',
  'custom-sites-extensions.spotlight.spotlight-config-panel.button-heading': '按鈕',
  'custom-sites-extensions.spotlight.spotlight-config-panel.button-text-placeholder': '檢視',
  'custom-sites-extensions.spotlight.spotlight-config-panel.dark-button-style-label': '替代方案',
  'custom-sites-extensions.spotlight.spotlight-config-panel.delete-icon-label': '刪除',
  'custom-sites-extensions.spotlight.spotlight-config-panel.light-button-style-label': '預設',
  'custom-sites-extensions.spotlight.spotlight-config-panel.mdia-picker-helper-message':
    '選擇 1200px 或更寬的高解析度圖片，以呈現最佳效果。',
  'custom-sites-extensions.spotlight.spotlight-config-panel.media-picker-button-label': '選擇媒體',
  'custom-sites-extensions.spotlight.spotlight-config-panel.media-picker-content-title': '媒體',
  'custom-sites-extensions.unsplash-search.default-image-picker.no-image': '沒有圖片',
  'custom-sites-extensions.unsplash.background-img.default.label': '上傳預覽器的預設背景圖片',
  'custom-sites-extensions.unsplash.delete.image.text': '移除圖片',
  'custom-sites-extensions.unsplash.error.bad-request-message':
    '我們無法從 Unsplash 取得回應。請重新整理，然後再試一次。',
  'custom-sites-extensions.unsplash.error.rate-limited-message': '我們無法從 Unsplash 取得回應。請稍候，然後再試一次。',
  'custom-sites-extensions.unsplash.legal':
    '使用來自 Unsplash 的圖片，即表示您同意其{unsplashLicenseLink}和{unsplashTermsOfServiceLink}。',
  'custom-sites-extensions.unsplash.license': '授權',
  'custom-sites-extensions.unsplash.search.error.no-network-message': '連線已中斷。請再試一次。',
  'custom-sites-extensions.unsplash.search.load.more.unsplash.photos': '載入更多',
  'custom-sites-extensions.unsplash.search.no.more.results.to.load.text': '沒有更多相符項目，請嘗試其他搜尋',
  'custom-sites-extensions.unsplash.search.no.results.text': '沒有任何項目符合您的搜尋內容',
  'custom-sites-extensions.unsplash.terms.of.service.': '服務條款',
  'custom-sites-extensions.unsplash.upload.label': '上傳',
  'custom-sites-extensions.unsplash.upload.text': '上傳',
  label: '卡片數目',
};
